module.exports = __webpack_public_path__ + "assets/img/thumb-Interiors-Australia-Landing-Page.bc81b4a6.webp";